<template>
  <div class="public-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'PublicLayout'
}
</script>
